/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Personal / Commercial License.
 * See LICENSE_PERSONAL / LICENSE_COMMERCIAL in the project root for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';

@Injectable()
export class TitleService {
  currentTitle: any = 'Properties Project';
  currentSubTitle: any;
  projectIdTitle: any;
  idUserTitle: any;
  currentProject: any;
  userProject: any;
}
